/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum HydricBalanceAliases {
  HYDRIC_BALANCE_CARD = 'hydric-balance-card',
  HYDRIC_BALANCE_CAROUSEL = 'hydric-balance-carousel',
  HYDRIC_BALANCE_CONTEXTUAL_BAR = 'hydric-balance-contextual-bar',
  HYDRIC_BALANCE_DATE_PICKER_FINAL_DATE = 'hydric-balance-date-picker-final-date',
  HYDRIC_BALANCE_DATE_PICKER_INITIAL_DATE = 'hydric-balance-date-picker-initial-date',
  HYDRIC_BALANCE_FETCH = 'hydric-balance-fetch',
  HYDRIC_BALANCE_FILTER = 'hydric-balance-filter',
  HYDRIC_BALANCE_FILTER_FIELD_DATE_END = 'hydric-balance-filter-field-date-end',
  HYDRIC_BALANCE_FILTER_FIELD_DATE_START = 'hydric-balance-filter-field-date-start',
  HYDRIC_BALANCE_FILTERED_LIST = 'hydric-balance-filtered-list',
  HYDRIC_BALANCE_LAYOUT = 'hydric-balance-layout',
  HYDRIC_BALANCE_PANEL = 'hydric-balance-panel',
}
export { HydricBalanceAliases };
